import React from "react";
import { Card, Alert, Spin, Descriptions, Tag, Typography, Space, Divider, Button, message } from "antd";
import { FileProtectOutlined, UserOutlined, EnvironmentOutlined, CopyOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

const { Text } = Typography;

export const PolizarioEdega = () => {
  const { edegaContrato, edegaDetalleReclamo, loadingEdega, vistaEdega } = useSelector(
    (state) => state.polizarioReducer
  );
  const { validador1, polizarioBloqueado } = useSelector((state) => state.asistenciasReducer.captura);

  const copiarTodo = () => {
    const texto = `Folio: ${validador1}
SI UID: ${edegaContrato?.si_uid || ""}
CT UID: ${edegaContrato?.ct_uid || ""}
SI Folio: ${edegaContrato?.si_folio || ""}
Tiene reclamo: ${edegaContrato?.tieneReclamo ? "Si" : "No"}

--- Cliente ---
Nombre: ${edegaDetalleReclamo?.nombre || ""} ${edegaDetalleReclamo?.apellidos || ""}
Email: ${edegaDetalleReclamo?.email || ""}
Telefono: ${edegaDetalleReclamo?.lada || ""} ${edegaDetalleReclamo?.telefono || ""}

--- Servicio ---
CP suceso: ${edegaDetalleReclamo?.cp_suceso || ""}
CP atencion: ${edegaDetalleReclamo?.cp_atencion || ""}
Tipo celular: ${edegaDetalleReclamo?.tipoCelular || ""}
Tipo servicio: ${edegaDetalleReclamo?.tipoServicio || ""}`;

    navigator.clipboard.writeText(texto)
      .then(() => {
        message.success("Datos copiados al portapapeles");
      })
      .catch(() => {
        message.error("No se pudieron copiar los datos");
      });
  };

  return (
    <Card size="small">
      <div className="crear-servicios-v2__section-header">
        <div className="crear-servicios-v2__section-header-title">
          <FileProtectOutlined />
          <span>Polizario Edega</span>
        </div>
      </div>

      {!validador1 && (
        <Alert message="Ingrese un validador y presione Buscar" type="info" />
      )}

      {validador1 && loadingEdega && (
        <div style={{ textAlign: "center", padding: 24 }}>
          <Spin />
        </div>
      )}

      {validador1 && !loadingEdega && edegaContrato?.tieneReclamo === false && (
        <Alert message="Sin reclamo previo." type="success" showIcon />
      )}

      {validador1 && !loadingEdega && vistaEdega === 0 && polizarioBloqueado && (
        <Alert message="No se puede generar servicio para este folio." type="warning" showIcon />
      )}

      {validador1 && !loadingEdega && vistaEdega === 0 && !polizarioBloqueado && edegaContrato?.tieneReclamo !== false && (
        <Alert message="Presione Buscar para consultar" type="info" showIcon />
      )}

      {validador1 && !loadingEdega && vistaEdega === 1 && edegaContrato?.tieneReclamo === true && (
        <Space direction="vertical" style={{ width: "100%" }}>
          <Alert message="No se puede generar servicio para este folio." type="warning" showIcon />
          <Space wrap>
            {/* <Text strong style={{ fontSize: 15 }}>{edegaContrato?.si_folio || validador1}</Text> */}
            <Tag color={edegaContrato?.tieneReclamo ? "error" : "default"}>
              {edegaContrato?.tieneReclamo ? "Con reclamo" : "Sin reclamo"}
            </Tag>
            <Button icon={<CopyOutlined />} size="small" onClick={copiarTodo}>
              Copiar todo
            </Button>
          </Space>

          <Divider orientation="left" plain style={{ margin: "8px 0" }}>
            <Space><FileProtectOutlined /><Text type="secondary" style={{ fontSize: 12 }}>Contrato</Text></Space>
          </Divider>
          <Descriptions column={1} size="small">
            <Descriptions.Item label="SI UID">{edegaContrato?.si_uid}</Descriptions.Item>
            <Descriptions.Item label="CT UID">{edegaContrato?.ct_uid}</Descriptions.Item>
            <Descriptions.Item label="SI Folio">{edegaContrato?.si_folio}</Descriptions.Item>
          </Descriptions>

          <Divider orientation="left" plain style={{ margin: "8px 0" }}>
            <Space><UserOutlined /><Text type="secondary" style={{ fontSize: 12 }}>Cliente</Text></Space>
          </Divider>
          <Descriptions column={2} size="small">
            <Descriptions.Item label="Nombre" span={2}>
              {`${edegaDetalleReclamo?.nombre || ""} ${edegaDetalleReclamo?.apellidos || ""}`.trim()}
            </Descriptions.Item>
            <Descriptions.Item label="Telefono">
              {`${edegaDetalleReclamo?.lada || ""} ${edegaDetalleReclamo?.telefono || ""}`.trim()}
            </Descriptions.Item>
            <Descriptions.Item label="Email">{edegaDetalleReclamo?.email}</Descriptions.Item>
          </Descriptions>

          <Divider orientation="left" plain style={{ margin: "8px 0" }}>
            <Space><EnvironmentOutlined /><Text type="secondary" style={{ fontSize: 12 }}>Servicio</Text></Space>
          </Divider>
          <Descriptions column={2} size="small">
            <Descriptions.Item label="CP suceso">{edegaDetalleReclamo?.cp_suceso}</Descriptions.Item>
            <Descriptions.Item label="CP atencion">{edegaDetalleReclamo?.cp_atencion}</Descriptions.Item>
            <Descriptions.Item label="Tipo celular">{edegaDetalleReclamo?.tipoCelular}</Descriptions.Item>
            <Descriptions.Item label="Tipo servicio">{edegaDetalleReclamo?.tipoServicio}</Descriptions.Item>
          </Descriptions>
        </Space>
      )}
    </Card>
  );
};
